import { FINANCING_TERMS_PATH } from './routePaths';

export const routes = {
  [FINANCING_TERMS_PATH]: {
    path: FINANCING_TERMS_PATH,
    displayName: 'Financing',
    breadcrumbBackUrl: '/',
    description: 'View Terms',
    featureFlag: 'shouldShowFinancingTermsTab'
  }
};

export default routes;
